import script from "./SwapCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SwapCard.vue?vue&type=script&setup=true&lang=js"

import "./SwapCard.vue?vue&type=style&index=0&id=ce4d8116&lang=css"

const __exports__ = script;

export default __exports__